// frontend/web-ui/src/components/lists/picker/adapters.ts
import type {
  SearchReleaseItem,
  SearchSeriesItem,
} from "../../../screens/search/types";
import type { PickerItem } from "./types";

export function mapSeriesToPickerItem(item: SearchSeriesItem): PickerItem {
  const subtitle = [
    item.releases_count_string ?? `${item.total_releases} issues`,
    item.artist_name,
  ]
    .filter(Boolean)
    .join(" • ");
  return {
    id: item.id,
    title: item.name,
    subtitle,
    coverUrl: item.cover_image_url,
  };
}

export function mapReleaseToPickerItem(item: SearchReleaseItem): PickerItem {
  const subtitle = [item.comic_name, item.artist_name]
    .filter(Boolean)
    .join(" • ");
  return {
    id: item.id,
    title: item.title,
    subtitle,
    coverUrl: item.thumbnail_url ?? undefined,
  };
}
